// converts low priority TTY styles into normal stylesheets links,
// once the important content has been requested
function handlePreloadedStyles() {
  const preloadedStyles:NodeListOf<HTMLLinkElement> = document.querySelectorAll('link[data-preloaded-style]');

  if (preloadedStyles.length) {
    preloadedStyles.forEach((style) => {
      const href = style.getAttribute('href');
      const currentStyle:HTMLLinkElement = document.querySelector(`link[href='${href}']`);
      if (currentStyle && currentStyle.getAttribute('media') !== 'tty') return false;

      const link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('media', 'screen');
      link.setAttribute('href', href);
      document.head.appendChild(link);

      // don't double load already preloaded styles on Turbolinks visits
      style.removeAttribute('data-preloaded-style');

      return true;
    });
  }
}

(() => {
  handlePreloadedStyles();

  window.removeEventListener('turbolinks:load', handlePreloadedStyles);
  window.addEventListener('turbolinks:load', handlePreloadedStyles);
})();
